import { Grid, Typography } from '@mui/material';
import React from 'react';
import { isMobile } from 'react-device-detect';
import Slider from 'react-slick';

const Clients = () => {

    const settings = {
        dots: false,
        dotsClass: 'slick-dots',
        arrows: false,
        className: 'center',
        centerMode: false,
        infinite: true,
        centerPadding: '20px',
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        swipeToSlide: false,
        speed: 500,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              dots: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              dots: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 0,
              centerMode: false,
            },
          },
        ],
      };
const imgHeight = isMobile ? 40 : 60;
const sliderss = [
    <Grid key={'6'} item sx={{display:'flex !important', justifyContent:'center', px:10}}>
        <img src='/assets/images/clients/acil-logo.png' style={{height:imgHeight}} alt="6" />
    </Grid>,
    
    <Grid key={'6'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/airindia-logo.png' style={{height:imgHeight}} alt="6" />
    </Grid>,
    <Grid key={'6'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/amazon-logo.png' style={{height:imgHeight}} alt="6" />
    </Grid>,
    <Grid key={'6'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/amity-logo.png' style={{height:imgHeight}} alt="6" />
    </Grid>,
    <Grid key={'6'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/bharti-logo.png' style={{height:imgHeight}} alt="6" />
    </Grid>,
    <Grid key={'6'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/britannia-logo.png' style={{height:imgHeight}} alt="6" />
    </Grid>,
    <Grid key={'6'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/gmr-logo.png' style={{height:imgHeight}} alt="6" />
    </Grid>,
    <Grid key={'7'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/kelloggs-logo.png' style={{height:imgHeight}}  alt="7" />
    </Grid>,
    <Grid key={'9'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/marriott-logo.png' style={{height:imgHeight}} alt="9" />
    </Grid>,
    <Grid  key={'10'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/pepsi-logo.png' style={{height:imgHeight}} alt="10" />
    </Grid>,
    <Grid key={'11'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/pnb-logo.png' style={{height:imgHeight}} alt="11" />
    </Grid>,
    <Grid key={'12'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/png-logo.png' style={{height:imgHeight}} alt="12" />
    </Grid>,
    <Grid key={'12'} item sx={{display:'flex !important', justifyContent:'center'}}>
        <img src='/assets/images/clients/samsung-logo.png' style={{height:imgHeight}} alt="12" />
    </Grid>
]



return (
    <Grid item sx={{backgroundColor:'#F4F8FA', width:'100%', display:'flex', justifyContent:'center'}}>
        <Grid className='client-div' sx={{width:'100%', maxWidth:1440, pt: !isMobile? '5em' : '4em', pb: !isMobile? '7em': '5em'}}>
            
            <Typography variant='h4' component={'h4'} className='titleStyle title-color client-title' sx={{mb:2}}>
                            Clients we serve</Typography>
            <Grid item xs={12} sx={{mt:'3em'}}>
                <Slider className='client-slider' {...settings}>{sliderss}</Slider>
                {/* <Grid item xs={2} sm={2}>
                    <img src='/assets/images/coke.png' style={{width:'auto', maxWidth:'100%'}} alt="" />
                </Grid>
                <Grid item xs={2} sm={2}>
                    <img src='/assets/images/schiender.png' style={{width:'auto', maxWidth:'100%'}} alt="" />
                </Grid>
                <Grid item xs={2} sm={2}>
                    <img src='/assets/images/spaze.png' style={{width:'auto', maxWidth:'100%'}} alt="" />
                </Grid>
                <Grid item xs={2} sm={2}>
                    <img src='/assets/images/pg.png' style={{width:'auto', maxWidth:'100%'}} alt="" />
                </Grid>
                <Grid item xs={2} sm={2}>
                    <img src='/assets/images/mariott.png' style={{width:'auto', maxWidth:'100%'}} alt="" />
                </Grid> */}
            </Grid>

     <br></br><br></br><br></br>       
<Typography variant='h4' component={'h4'} className='titleStyle title-color client-title' sx={{mb:2}}>
                            Our Journey So Far</Typography>
                    <Typography variant='bod2' component={'p'} className={'text-color'} 
                        sx={{pl:1, fontFamily:'Inter',lineHeight:'1.8em', mt:1, mb:2, overflowWrap:true, textOverflow:'ellipsis', overflow:'hidden'}}>
                       Over the years, we have worked across many sectors, residential buildings, industrial sheds, hospitals, malls, corporate offices, and educational campuses. The variety has shaped our strength. We are now a full-service <strong>MEP company in India</strong> with deep experience across all kinds of infrastructure.<br></br>
What keeps clients coming back is not just our technical skills, it is our reliability. When we say we will deliver, we do. On time. Within scope. No surprises.

                    </Typography>


                    <Typography variant='h4' component={'h4'} className='titleStyle title-color client-title' sx={{mb:2}}>
                            Why Work With Us?</Typography>
                    <Typography variant='bod2' component={'p'} className={'text-color'} 
                        sx={{pl:1, fontFamily:'Inter',lineHeight:'1.8em', mt:1, mb:2, overflowWrap:true, textOverflow:'ellipsis', overflow:'hidden'}}>
                       If you are looking for more than just a vendor, if you want a partner who understands both design and practicality, you are in the right place.<br></br>
As a <strong>MEP company in India</strong> with a proven track record, we help you simplify decisions, avoid costly mistakes, and get the results you want. We offer personal support, real-time updates, and a commitment to your success.<br></br>
Let us help you build smarter, safer, and more efficient spaces - starting now.


                    </Typography>

            <>
<div container style={{width:'100%', justifyContent:'center', margin:'50px 0px 50px'}} className='cussec'>

<section class="mep-content">

<h1><b>MEP Services Company in India - Precision-Built, Purpose-Led</b></h1>

<p>Precision is not a luxury. In industrial environments, it is survival. At <a href="https://www.uniqueengineersltd.com/"><b>Unique Engineers</b></a>, every screw, pipe, and wire is more than just a part of a system, it is a decision. One made with intent, expertise, and foresight. This is not about “delivering services.” It is about engineering spaces that breathe, respond, and last.</p>

<h2><b>Why Choose a Trusted MEP Company in India</b></h2>

<p>When multiple systems work under one roof, integration becomes mission-critical. Mechanical, Electrical, and Plumbing services are not standalone tasks, they are the lifeblood of your building’s functionality.</p>

<p>As an experienced <b>MEP company in India</b>, we understand this intersection well. We engineer coordination. We do not juggle services. We bring every strand of your infrastructure together with clarity and discipline.</p>

<p>Here is what sets us apart:</p>

<ul>
  <li>Seamless in-house execution across all MEP disciplines</li>
  <li>Design-optimised delivery, not just code compliance</li>
  <li>Transparent timelines and accountable project tracking</li>
  <li>Experienced teams trained in live-site challenges</li>
  <li>Nationwide reach with local adaptability</li>
</ul>

<h2><b>MEP Contractor in India with a Ground-Level Understanding</b></h2>

<p>Complex projects do not fail due to complexity, they fail due to oversight. Being a top <b>MEP Contractor in India</b>, at Unique Engineers, we stay on the ground. We map technical scope with field logic, not just design diagrams.</p>

<p>We provide full-service MEP execution for:</p>

<ul>
  <li>Industrial facilities</li>
  <li>Commercial buildings</li>
  <li>Data centres</li>
  <li>Healthcare and pharma units</li>
  <li>Residential and high-rise buildings</li>
</ul>

<p>We do not delegate responsibility. We carry it, system to system, until sign-off.</p>

<h2><b>Working With Top MEP Companies in India - What Should You Expect?</b></h2>

<p>There is a difference between hiring a vendor and working with a partner. <b>Top MEP companies in India</b> bring more than tools, they bring methods.</p>

<p>Unique Engineers brings:</p>

<ul>
  <li>Early involvement in planning to prevent design reworks</li>
  <li>Value engineering that preserves quality, not just reduces cost</li>
  <li>Accurate BOQ estimation with no last-minute surprises</li>
  <li>On-site supervision with skilled manpower and safety compliance</li>
  <li>Interdisciplinary integration for seamless handover</li>
</ul>

<p>Our goal is not to mark the job as "done". Our goal is to make it "work".</p>

<h2><b>Integrated MEP Services in India - Delivered With Full Ownership</b></h2>

<p>Within MEP services, time is currency. Miscommunication leads to rework, and rework costs more than just money. It delays occupancy. It compromises safety. It dents reputation.</p>

<p>Unique Engineers manages <b>MEP services in India</b> with an integrated model:</p>

<ul>
  <li>One single team for M, E and P - no coordination gaps</li>
  <li>Clear accountability structure - no grey areas</li>
  <li>Smart sequencing of activities to avoid site conflicts</li>
  <li>Technology-enabled reporting for real-time visibility</li>
</ul>

<p>We keep the site moving, even when the design evolves. Especially when it evolves.</p>

<h2><b>Why Unique Engineers Holds Ground Among the Top HVAC Companies in India</b></h2>

<p>In HVAC, performance is not judged by installation, it is judged by comfort, control, and cost-efficiency across seasons.</p>

<p>As a reputed <a href="https://www.uniqueengineersltd.com/services/hvac-company-in-india/"><b>HVAC company in India</b></a>, we offer:</p>

<ul>
  <li>Custom HVAC solutions for industrial, cleanroom, and data environments</li>
  <li>Advanced airflow studies and heat load analysis</li>
  <li>System designs that optimise energy, not just meet codes</li>
  <li>After-installation support and lifecycle cost management</li>
</ul>

<p>Our designs think beyond today’s temperatures.</p>

<h2><b>Our Scope Also Covers Electrical, Fire and Air Conditioning Services</b></h2>

<p>Our clients trust us as a single-point partner for complete MEPF scope. That trust has grown with consistent delivery across specialised trades.</p>

<ul>
  <li><a href="https://www.uniqueengineersltd.com/services/industrial-fire-fighting-contractors-in-india/"><b>Fire Fighting Contractors in India</b></a> - High-reliability suppression systems for industrial and high-risk environments</li>
  <li><a href="https://www.uniqueengineersltd.com/services/air-conditioning-contractor-in-india/"><b>Air Conditioning Contractor in India</b></a> - Precision cooling solutions for sensitive spaces like labs and server rooms</li>
  <li><a href="https://www.uniqueengineersltd.com/services/industrial-electrical-contractors-in-india/"><b>Industrial Electrical Contractors in India</b></a> - Power distribution that supports peak loads and redundancy</li>
  <li><a href="https://www.uniqueengineersltd.com/services/mepf-contractor-in-india/"><b>MEPF Contractor in India</b></a> - Full-spectrum mechanical, electrical, plumbing and fire protection under one roof</li>
</ul>

<p>Your systems do not work in isolation. Neither do we.</p>

<h3><b>Our Project Mindset: Clean Execution. No Drama.</b></h3>

<p>Some firms chase scale. We focus on readiness. Whether it is a 20,000 sq. ft. warehouse or a 2 million sq. ft. plant, we come prepared.</p>

<p>Our execution includes:</p>

<ul>
  <li>Thorough site assessment before mobilisation</li>
  <li>Skilled, uniformed manpower trained in industrial protocol</li>
  <li>Consistent reporting cadence</li>
  <li>Regulatory compliance from Day One</li>
</ul>

<p>We are not here to impress you with jargon. We are here to deliver buildings that work, and keep working.</p>

<h3><b>Not Just Another Name Among Top MEP Companies in India</b></h3>

<p>At Unique Engineers, we do not believe in promising “more.” We believe in getting things right the first time.</p>

<p>You can visit several MEP contractors in India, who may offer cheaper, faster, and flashier services. But what you will not find often is consistency, reliability, and mature ownership from start to finish. We are not here to rush to L1. We are here to be the last vendor you need to call.</p>

<p><b>Ready to build something that lasts?</b> Let us talk about systems, not just services.</p>



</section>

&nbsp;
<h4><b>Frequently Asked Questions (FAQs)</b></h4>

<details open className='cusfq'>
  <summary>1. What makes Unique Engineers a reliable MEP contractor in India?</summary>
  <p>We take full responsibility from planning to handover. No service is outsourced. No scope is loosely defined. Every part of your system is accounted for and delivered with precision.
</p>
</details>

<details className='cusfq'>
  <summary>2. How do you ensure project timelines are met?</summary>
  <p>We operate with in-house teams and tightly controlled schedules. Our planning approach ensures minimum overlap and maximum progress.</p>
</details>

<details className='cusfq'>
  <summary>3. Do you offer MEP services across India?</summary>
  <p>Yes. Our operations span across industrial and commercial hubs throughout India, adapting to local regulations and project conditions.</p>
</details>

<details className='cusfq'>
  <summary>4. Can you handle high-scale industrial HVAC installations?</summary>
  <p>Absolutely. Our HVAC team has delivered cleanroom-compliant and large-volume cooling systems for manufacturing, pharma and data centres.</p>
</details>

<details className='cusfq'>
  <summary>5. What sectors do you typically serve?</summary>
  <p>We serve industrial, commercial, healthcare, warehousing, and mixed-use developments. Our systems are scalable and tailored to sector-specific needs.</p>
</details>



</div>
</>
        </Grid>
    </Grid>

    
)

}

export default Clients;